import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { commonDataGridStyles } from '../../styles/dataGridStyles';

const EmployeesTable = ({ employees, searchTerm }) => {
    // Filter employees based on search term - by fullName, phone, and email
    const filteredEmployees = employees.filter(employee => {
        if (!searchTerm) return true;
        const search = searchTerm.toLowerCase();
        return (
            employee.fullName?.toLowerCase().includes(search) ||
            employee.phone?.toLowerCase().includes(search) ||
            employee.email?.toLowerCase().includes(search)
        );
    });

    const columns = [
        {
            field: 'fullName',
            headerName: 'Full Name',
            flex: 1,
            minWidth: 250,
            renderCell: (params) => (
                <div style={{ 
                    fontWeight: 500,
                    whiteSpace: 'normal',
                    wordWrap: 'break-word',
                    lineHeight: 1.4
                }}>
                    {params.value || '-'}
                </div>
            )
        },
        {
            field: 'phone',
            headerName: 'Phone',
            width: 150,
            renderCell: (params) => (
                <div style={{ 
                    color: '#666',
                    fontFamily: 'monospace'
                }}>
                    {params.value || '-'}
                </div>
            )
        },
        {
            field: 'division',
            headerName: 'Division',
            width: 100,
            renderCell: (params) => (
                <div style={{ 
                    color: '#666',
                    textAlign: 'center',
                    width: '100%'
                }}>
                    {params.value || '-'}
                </div>
            )
        },
        {
            field: 'email',
            headerName: 'Email',
            flex: 1,
            minWidth: 200,
            renderCell: (params) => (
                <div style={{ 
                    color: '#666',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                }}>
                    {params.value || '-'}
                </div>
            )
        },
        {
            field: 'MVR',
            headerName: 'MVR',
            width: 120,
            renderCell: (params) => {
                const value = params.value || params.row.mvr || params.row.mVR;
                const isYes = value && (value.toUpperCase() === 'YES');
                return (
                    <div style={{ 
                        color: isYes ? '#4CAF50' : '#666',
                        textAlign: 'center',
                        width: '100%',
                        fontWeight: isYes ? 'bold' : 'normal'
                    }}>
                        {isYes ? 'YES' : '-'}
                    </div>
                );
            }
        }
    ];

    return (
        <DataGrid
            rows={filteredEmployees}
            columns={columns}
            initialState={{
                pagination: {
                    paginationModel: { pageSize: 25 }
                }
            }}
            pageSizeOptions={[25, 50, 100]}
            disableSelectionOnClick
            getRowId={(row) => row.id}
            rowHeight={60}
            sx={commonDataGridStyles}
        />
    );
};

export default EmployeesTable;